module.exports = __webpack_public_path__ + "media/images/triangle--down--rb-dark-blue-1e363f8b7004e1a2110d20d167e73701.png";